import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL } from "../../../store/constans";

// import rolfWittmerLogo from '../../../../../assets/rolf.png';

export default function FormPDF(
    datos,
    formulario
) {
    var doc = new jsPDF("p", "pt");

    doc.setFont("helvetica", "normal");
    var yIncrementalPosition = 50;
    var lineBreak = 12;
    var doubleLineBreak = 24;
    var tripleLineBreak = 36;
    const imgWidth = 600;
    const imgHeight = 40;
    const imgX = 0;
    const imgY = doc.internal.pageSize.height - imgHeight - 10;

    const logo = `${API_BASE_URL}/uploads/school/logo_doc.png`;

    var date = new Date();
    var monthList = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];

    // HEADER
    doc.setFontSize(12);
    doc.addImage(logo, "JPEG", 230, 20, 150, 50);
    doc.setFont("helvetica", 'bold')
    doc.text(date.getDate() + " de " + monthList[date.getMonth()] + " del " + date.getFullYear(), 250, (yIncrementalPosition += tripleLineBreak));

    doc.setFontSize(10);
    doc.setFont("helvetica", 'normal')
    doc.text(formulario.formulario.titulo, 30, (yIncrementalPosition += tripleLineBreak));
    doc.text("Representante: " + datos?.nombre_representante, 30, (yIncrementalPosition += lineBreak));
    doc.text("Estudiante: " + datos?.nombre_estudiante, 30, (yIncrementalPosition += lineBreak));
    doc.text("Fecha de contestacion: " + datos.today, 30, (yIncrementalPosition += lineBreak));

    // BODY
    formulario.respuestas?.forEach((response) => {
        // Comprobamos si queda espacio suficiente para una nueva pregunta
        if (yIncrementalPosition > doc.internal.pageSize.height - 100) {
            doc.addPage();
            yIncrementalPosition = 50; // reinicia el valor al iniciar nueva página
        }

        doc.setFont("helvetica", 'bold');
        doc.text(`${response.pregunta?.textQuestion}`, 30, (yIncrementalPosition += tripleLineBreak));

        if (yIncrementalPosition > doc.internal.pageSize.height - 50) {
            doc.addPage();
            yIncrementalPosition = 50;
        }

        doc.setFont("helvetica", 'normal');
        doc.text(response.answer, 30, (yIncrementalPosition += lineBreak));
    });
    // ADD FOOTER
    //addFooter(doc);

    // GENERATE PDF
    doc.save(formulario.formulario.titulo + '_' + datos?.nombre_estudiante + ".pdf");
}